Array.prototype.findByID = function(id, key = "ID") {
  id = parseInt(id);
  if (isNaN(id)) return null;
  for (let i = 0; i < this.length; i++) {
    if (this[i][key] == id) return this[i];
  }
  return null;
};
Array.prototype.contain = function(val) {
  for (let i = 0; i < this.length; i++) {
    if (this[i] == val) return true;
  }
  return false;
};
Element.prototype.getOffsetTop = function() {
  let top = this.offsetTop;
  let parent = this.offsetParent;
  while (parent != null) {
    top += parent.offsetTop;
    parent = parent.offsetParent;
  }
  return top;
};
String.prototype.count = function(substr) {
  let count = 0;
  let reg = "/" + substr + "/g";
  reg = eval(reg);
  if (this.match(reg) == null) {
    count = 0;
  } else {
    count = this.match(reg).length;
  }
  return count;
};
Array.prototype.indexOf = function(val) {
  for (let i = 0; i < this.length; i++) {
    if (this[i] == val) return i;
  }
  return -1;
};
Array.prototype.remove = function(val) {
  let index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};